import { render, staticRenderFns } from "./FormArrepentimiento.vue?vue&type=template&id=3299bded&scoped=true"
import script from "./FormArrepentimiento.vue?vue&type=script&lang=js"
export * from "./FormArrepentimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299bded",
  null
  
)

export default component.exports